module.exports = __webpack_public_path__ + "media/images/og-ko-1310fe15c7b1fa7e5e4b6c382a921ee7.jpg";